<template>
    <div class="m-jx3dat-rank-mini m-jx3dat-rank">
        <h3 class="c-sidebar-right-title">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" v-bind:class="'u-icon'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g fill="#ffa91e"><path d="M324.891 167.266l16.262 94.815L256 217.314l-85.153 44.767 16.262-94.815-68.891-67.16 95.205-13.833L256 0l42.577 86.273 95.205 13.833z"/><path d="M409.944 253.46v87.673L256.9 403.303l-.9-.36-153.944-61.76V253.46L256 315.219z"/><path d="M409.944 362.157v87.673L256.9 512l-.9-.36-153.944-61.76v-87.723L256 423.916z"/></g><g fill="#ff8900"><path d="M341.153 262.081L256 217.314V0l42.577 86.273 95.205 13.833-68.891 67.16zM409.944 253.46v87.673L256.9 403.303l-.9-.36v-87.724zM256 423.916l153.944-61.759v87.673L256.9 512l-.9-.36z"/></g></svg>排行榜
            <span class="u-more" @click="viewRank">查看更多 &raquo;</span>
        </h3>
        <el-tabs v-model="active" @tab-click="handleClick">
            <el-tab-pane label="综合" name="mix"></el-tab-pane>
            <el-tab-pane label="下载" name="download"></el-tab-pane>
            <el-tab-pane label="订阅" name="subscribers"></el-tab-pane>
            <el-tab-pane label="收藏" name="favorite"></el-tab-pane>
        </el-tabs>
        <ul class="u-list" v-loading="loading">
            <li v-for="(item, k) in data" :key="k">
                <a class="u-link" :href="postLink('dbm/pkg', item.id)">
                    <span class="u-order" :class="highlight(k)">{{ k + 1 }}</span>
                    <Avatar class="u-avatar" :url="item.ext_user_info.avatar" :size="14"> </Avatar>
                    <!-- <span class="u-tag" :class="item.client">{{ item.client === "std" ? "重制" : "缘起" }}</span> -->
                    <span class="u-name"> {{ item.key }} </span>
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
import { getPkgRank } from "../../service/rank";
import { postLink } from "@jx3box/jx3box-common/js/utils";
import { __Root, __OriginRoot } from "@jx3box/jx3box-common/data/jx3box.json";
export default {
    name: "rank",
    data: function () {
        return {
            loading: false,
            data: [],
            active: "mix",
        };
    },
    computed: {
        client: function () {
            return this.$store.state.client;
        },
    },
    methods: {
        postLink,
        handleClick() {
            this.loadData();
        },
        viewRank: function () {
            const root = this.client === "std" ? __Root : __OriginRoot;
            window.open(`${root}dbm/pkg/rank`, "_blank");
        },
        highlight: function (i) {
            if (i == 0) {
                return "t1";
            } else if (i == 1) {
                return "t2";
            } else if (i == 2) {
                return "t3";
            }
        },
        loadData() {
            this.loading = true;
            getPkgRank(this.active, { top: 10, client: this.client })
                .then((res) => {
                    this.data = res.data.data;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
    mounted: function () {
        this.loadData();
    },
};
</script>

<style lang="less">
@import "../../assets/css/rank.less";
</style>
